var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.info.title,
        visible: _vm.visible,
        "append-to-body": "",
        "destroy-on-close": "",
        "close-on-click-modal": false,
        width: "55%",
        center: "",
        "show-close": false,
        "custom-class": "dialog-box",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.closeEdit,
        open: _vm.openEdit,
      },
    },
    [
      _c(
        "div",
        { staticClass: "info-title", attrs: { slot: "title" }, slot: "title" },
        [
          _c("img", {
            staticClass: "info-bg",
            attrs: {
              src: require("@/static/icon_announcement_bg.png"),
              alt: "",
            },
          }),
          _vm.info.publishTime
            ? _c("div", { staticClass: "info-time" }, [
                _vm._v("发布时间：" + _vm._s(_vm.info.publishTime)),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "font-18 flex flex-center",
          staticStyle: { "font-weight": "700" },
        },
        [_vm._v(_vm._s(_vm.info.title))]
      ),
      _c("div", { staticClass: "font-16 flex flex-center margin-top-10" }, [
        _vm._v(_vm._s(_vm.info.subTitle)),
      ]),
      _c("div", { staticStyle: { "max-height": "40vh", overflow: "auto" } }, [
        _c("div", {
          staticClass: "font-16 padding-x-20",
          domProps: { innerHTML: _vm._s(_vm.info.content) },
        }),
      ]),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              staticClass: "padding-x-40",
              attrs: { type: "primary" },
              on: { click: _vm.closeDetail },
            },
            [_vm._v("我知道了")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }